<div class="overlay-medium">
  <app-card-medium title="{{ 'New Project' | translate }}">
    <div class="content">
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <div style="overflow: auto;">
          <div class="form-group">
            <input formControlName="name" type="text" class="form-control"
              placeholder="{{ 'Location Name' | translate }}">
            <div *ngIf="formName?.invalid" class="text-danger">{{'Name is required' | translate}}</div>
          </div>
          <div class="form-group">
            <textarea formControlName="description" class="form-control" rows="3"
              placeholder="{{ 'Description' | translate }}"></textarea>
            <div *ngIf="formDescription?.invalid" class="text-danger">{{'Description is required' | translate}}</div>
          </div>
          <div style="margin-bottom: 13px;">
            <div class="input-group" style="margin-bottom: 0; padding-bottom: 0;">
              <input type="text" formControlName="coordinate" class="form-control"
                placeholder="{{ 'Longitude, Latitude' | translate }}">
              <div class="input-group-append">
                <button *ngIf="!isGetCoor" (click)="getMapLngLat()" class="btn btn-sm btn-primary" type="button">
                  <i class="icon-pointer"></i>
                </button>
                <button *ngIf="isGetCoor" (click)="disableMapClick()" class="btn btn-sm btn-secondary" type="button">
                  <i class="icon-pointer"></i>
                </button>
              </div>
            </div>
            <div style="padding-left: 0.3em;" *ngIf="formCoor?.errors?.required" class="text-danger">{{'Coordinate is required' | translate}}</div>
            <div style="padding-left: 0.3em;" *ngIf="!formCoor?.errors?.required && formCoor?.errors?.coordinateFormat" class="text-danger">{{'Invalid coordinate format' | translate}}</div>
          </div>
          <!-- <div class="form-group">
            <input (focus)="getMapLngLat()" formControlName="longitude" type="text" class="form-control"
              placeholder="{{ 'Longitude' | translate }}">
          </div>
          <div class="form-group">
            <input (focus)="getMapLngLat()" formControlName="latitude" type="text" class="form-control"
              placeholder="{{ 'Latitude' | translate }}">
          </div> -->
          <!-- HIDE FOR SUNtORY Build -->
          <!-- <div class="form-group">
            <input formControlName="default_zoom_level" type="text" class="form-control"
              placeholder="{{ 'Default Zoom Level' | translate }}">
            <small class="form-text text-muted"><small>Current zoom level: {{currZoomLevel | number}}.</small>&nbsp;<span class="set-default-zoom badge badge-secondary" (click)="setDefaultZoom(currZoomLevel)">Click to set</span></small>
          </div> -->
          <div class="form-group">
            <input formControlName="parent" type="text" class="form-control"
              placeholder="{{ 'Parent Location' | translate }}" (keyup)="searchParent($event)">
            <div #autoComplete class="auto-complete">
              <ul class="list-group">
                <li *ngFor="let parent of parentSelection; trackById" (click)="selectedParent(parent)" class="list-group-item">
                  {{ parent.name }}</li>
              </ul>
            </div>
          </div>
          <div class="form-group">
            <select formControlName="visibility" class="form-control">
              <option value="" disabled>{{ 'Visibility' | translate }}</option>
              <option value="private">{{ 'Private' | translate }}</option>
              <option value="public">{{ 'Public' | translate }}</option>
            </select>
            <div *ngIf="formVisibility?.invalid" class="text-danger">{{'Visibility is required' | translate}}</div>
          </div>

          <label>{{'Additional Data' | translate}}</label>

          <div class="form-row">
            <div class="col-5">
              <div class="form-group">
                <input type="text" class="form-control" placeholder="Key" formControlName="additional_data_key">
              </div>
            </div>
            <div class="col">
              <div class="input-group">
                <input type="text" class="form-control" placeholder="Value" formControlName="additional_data_val">
                <div class="input-group-append">
                  <button class="btn btn-primary btn-sm" type="button" (click)="addAD()"><i class="icon-create"></i></button>
                </div>
              </div>
            </div>
          </div>

          <div class="list-group">
            <a class="list-group-item list-group-item-action" *ngFor="let ad of locAdditionalData; let i = index">
              <div class="d-flex w-100 justify-content-between">
                <div>
                  <p class="mb-1">{{ad.key}}</p>
                  <small>{{ad.value}}</small>
                </div>
                <button class="btn btn-sm btn-danger" type="button" (click)="removeAD(i)"><i class="icon-delete"></i></button>
              </div>
            </a>
          </div>

        </div>
        <div class="form-buttons">
          <button type="button" class="btn btn-sm btn-secondary" backButton>{{ 'Cancel' | translate }}</button>
          <button [disabled]="form.invalid" type="submit" class="btn btn-sm btn-primary">{{ 'Save' | translate
            }}</button>
        </div>
      </form>
    </div>
  </app-card-medium>
</div>